module.exports = __webpack_public_path__ + "img/order_scheduled.5c2a20c7.png";